module.exports = __webpack_public_path__ + "static/8-magazine-40aaa4ee7999297aa8b2a0355625eb26.jpg";